export const planTypeDropdown = () => [
    { id: 1, description: 'Major Medical',          short: 'Major Medical' },
    { id: 2, description: 'Association Health Plan', short: 'AHP' },
    { id: 3, description: 'Ancillary',              short: 'Ancillary' },
];